var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21120_42095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21120_42095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.72852 15.8333H12.2702L11.8535 14.1667H8.14518L7.72852 15.8333ZM7.49935 12.5H12.4993C13.6521 12.5 14.6348 12.0938 15.4473 11.2812C16.2598 10.4688 16.666 9.48611 16.666 8.33333C16.666 7.18056 16.2598 6.19792 15.4473 5.38542C14.6348 4.57292 13.6521 4.16667 12.4993 4.16667H7.49935C6.34657 4.16667 5.36393 4.57292 4.55143 5.38542C3.73893 6.19792 3.33268 7.18056 3.33268 8.33333C3.33268 9.48611 3.73893 10.4688 4.55143 11.2812C5.36393 12.0938 6.34657 12.5 7.49935 12.5ZM8.82227 9.51042C8.49588 9.18403 8.33268 8.79167 8.33268 8.33333C8.33268 7.875 8.49588 7.48264 8.82227 7.15625C9.14865 6.82986 9.54102 6.66667 9.99935 6.66667C10.4577 6.66667 10.85 6.82986 11.1764 7.15625C11.5028 7.48264 11.666 7.875 11.666 8.33333C11.666 8.79167 11.5028 9.18403 11.1764 9.51042C10.85 9.83681 10.4577 10 9.99935 10C9.54102 10 9.14865 9.83681 8.82227 9.51042ZM5.41602 7.5C5.65213 7.5 5.85004 7.42014 6.00977 7.26042C6.16949 7.10069 6.24935 6.90278 6.24935 6.66667C6.24935 6.43056 6.16949 6.23264 6.00977 6.07292C5.85004 5.91319 5.65213 5.83333 5.41602 5.83333C5.1799 5.83333 4.98199 5.91319 4.82227 6.07292C4.66254 6.23264 4.58268 6.43056 4.58268 6.66667C4.58268 6.90278 4.66254 7.10069 4.82227 7.26042C4.98199 7.42014 5.1799 7.5 5.41602 7.5ZM3.33268 17.5V15.8333H6.02018L6.45768 14.0833C5.08268 13.8472 3.94032 13.191 3.0306 12.1146C2.12088 11.0382 1.66602 9.77778 1.66602 8.33333C1.66602 6.70833 2.23199 5.32986 3.36393 4.19792C4.49588 3.06597 5.87435 2.5 7.49935 2.5H12.4993C14.1243 2.5 15.5028 3.06597 16.6348 4.19792C17.7667 5.32986 18.3327 6.70833 18.3327 8.33333C18.3327 9.77778 17.8778 11.0382 16.9681 12.1146C16.0584 13.191 14.916 13.8472 13.541 14.0833L13.9785 15.8333H16.666V17.5H3.33268ZM12.3535 10.6875C13.0063 10.0347 13.3327 9.25 13.3327 8.33333C13.3327 7.41667 13.0063 6.63194 12.3535 5.97917C11.7007 5.32639 10.916 5 9.99935 5C9.08268 5 8.29796 5.32639 7.64518 5.97917C6.9924 6.63194 6.66602 7.41667 6.66602 8.33333C6.66602 9.25 6.9924 10.0347 7.64518 10.6875C8.29796 11.3403 9.08268 11.6667 9.99935 11.6667C10.916 11.6667 11.7007 11.3403 12.3535 10.6875Z",
    fill: "#133F7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraVideo);
export default __webpack_public_path__ + "static/media/camera_video.0b5da9993d16b6a55c0511b9f2152381.svg";
export { ForwardRef as ReactComponent };